import { DeleteOutlined } from "@ant-design/icons";
import { Button, Popconfirm } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import { defaultStatus } from "../../../../../helper/options";
import plusIcon from "../../../../../resources/plus.svg";

const TYPE_META = {
  tution:         { color: "#fa8c16", bg: "#fff7e6", label: "Tuition" },
  transportation: { color: "#1890ff", bg: "#e6f4ff", label: "Transport" },
  accommodation:  { color: "#52c41a", bg: "#f6ffed", label: "Accommodation" },
  daycare:        { color: "#722ed1", bg: "#f9f0ff", label: "Day Care" },
};

const TemplateListing = ({
  filteredData,
  handleDelete,
  setAddTemplate,
  type,
  setTemplateType,
}) => {
  const navigate = useNavigate();
  const meta = TYPE_META[type] || { color: "#8c8c8c", bg: "#fafafa", label: "Template" };
  const isApplied = (list) => list?.status === defaultStatus?.applied;

  return (
    <div style={{ padding: 20 }}>
      <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>

        {/* Cards grid — grows and wraps */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: 16, flex: 1, alignItems: "flex-start" }}>
        {filteredData && filteredData.length > 0 ? (
          filteredData.map((list) => (
            <div
              key={list?._id}
              style={{
                width: 168,
                background: "#fff",
                borderRadius: 12,
                boxShadow: "0 1px 4px rgba(0,0,0,0.08), 0 4px 12px rgba(0,0,0,0.04)",
                border: "1px solid #f0f0f0",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                position: "relative",
                transition: "box-shadow 0.2s, transform 0.15s",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0,0,0,0.12), 0 8px 24px rgba(0,0,0,0.06)";
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow =
                  "0 1px 4px rgba(0,0,0,0.08), 0 4px 12px rgba(0,0,0,0.04)";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              {/* Coloured top accent bar */}
              <div style={{ height: 4, background: meta.color, flexShrink: 0 }} />

              {/* Clickable body */}
              <div
                style={{ flex: 1, padding: "14px 14px 10px", display: "flex", flexDirection: "column", gap: 8 }}
                onClick={() =>
                  navigate(`/dashboard/admin/menu/fee/template/${list?._id}?type=${type}`)
                }
              >
                {/* Status badge */}
                <div>
                  <span
                    style={{
                      display: "inline-block",
                      fontSize: 10,
                      fontWeight: 700,
                      letterSpacing: 0.4,
                      padding: "2px 10px",
                      borderRadius: 20,
                      background: isApplied(list) ? "#f6ffed" : "#fffbe6",
                      color:      isApplied(list) ? "#389e0d" : "#d48806",
                      border:     `1px solid ${isApplied(list) ? "#b7eb8f" : "#ffe58f"}`,
                    }}
                  >
                    {isApplied(list) ? "Applied" : "Pending"}
                  </span>
                </div>

                {/* Template name */}
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#1f1f1f",
                    lineHeight: 1.4,
                    wordBreak: "break-word",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {list?.name}
                </div>

                {/* Meta row — year + type-specific info */}
                <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
                  {list?.year && (
                    <span style={{ fontSize: 11, color: "#8c8c8c" }}>
                      {list.year}
                    </span>
                  )}
                  {type === "transportation" && (
                    <span
                      style={{
                        fontSize: 11,
                        color: meta.color,
                        fontWeight: 600,
                        background: meta.bg,
                        display: "inline-block",
                        padding: "2px 8px",
                        borderRadius: 10,
                        width: "fit-content",
                      }}
                    >
                      {list?.destination_fees?.length ?? 0} stop
                      {(list?.destination_fees?.length ?? 0) !== 1 ? "s" : ""}
                    </span>
                  )}
                  {type === "accommodation" && (
                    <span
                      style={{
                        fontSize: 11,
                        color: meta.color,
                        fontWeight: 600,
                        background: meta.bg,
                        display: "inline-block",
                        padding: "2px 8px",
                        borderRadius: 10,
                        width: "fit-content",
                      }}
                    >
                      {list?.appliedCount ?? 0} student
                      {(list?.appliedCount ?? 0) !== 1 ? "s" : ""}
                    </span>
                  )}
                </div>
              </div>

              {/* Delete button — only for pending templates */}
              {!isApplied(list) && (
                <div
                  style={{
                    padding: "0 14px 12px",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Popconfirm
                    title="Are you sure to delete?"
                    onConfirm={() => handleDelete(list?._id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      type="primary"
                      danger
                      shape="circle"
                      size="small"
                      className="flex items-center justify-center"
                      icon={
                        <DeleteOutlined
                          style={{
                            fontSize: 11,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        />
                      }
                      style={{ width: 24, height: 24, minWidth: 24 }}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </Popconfirm>
                </div>
              )}
            </div>
          ))
        ) : (
          <div style={{ color: "#8c8c8c", fontSize: 13, paddingTop: 8 }}>
            No templates yet
          </div>
        )}
        </div>

        {/* Add button — pinned to the right */}
        <div
          onClick={() => {
            setAddTemplate(true);
            setTemplateType(type);
          }}
          className="cursor-pointer add-module flex items-center justify-center"
          style={{ width: 168, minHeight: 120, flexShrink: 0, borderRadius: 12 }}
        >
          <div className="flex flex-col items-center" style={{ gap: 8 }}>
            <img className="w-6 h-6" src={plusIcon} alt="icon" />
            <span
              className="text-white"
              style={{ fontSize: 11, textAlign: "center", maxWidth: 110 }}
            >
              {meta.label} Template
            </span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default TemplateListing;
